import script from "./CurrentUserDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CurrentUserDetailsView.vue?vue&type=script&setup=true&lang=ts"

import "./CurrentUserDetailsView.vue?vue&type=style&index=0&id=2bea5789&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bea5789"]])

export default __exports__